/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesFieldSetGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Field Set Group Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, March 06, 2019 - 12:44 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      03/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const FieldSetGroupList = Loadable({
    loader: () => import('../containers/FieldSetGroups/FieldSetGroupListContainer'),
    loading: Loading,
});

export const FieldSetGroupForm = Loadable({
    loader: () => import('../containers/FieldSetGroups/FieldSetGroupEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesFieldSetGroups.js